// store/slices/productFilterSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const getRandomPage = () => Math.floor(Math.random() * 10) + 1;
interface FilterState {
  sellerId: string | null;
  page: number;
  isBooks: boolean;
  filter: {
    searchString?: string | null;
    categories?: string[] | null;
    brand?: string[] | null;
    parentCategoryIdList?: number | null;
    author?: string | null;
    ISBN?: string | null;
  };
}

const initialState: FilterState = {
  sellerId: null,
  page: getRandomPage(),
  isBooks: false,
  filter: {},
};

const productFilterSlice = createSlice({
  name: "productFilter",
  initialState,
  reducers: {
    setProductFilter: (state, action: PayloadAction<Partial<FilterState>>) => {
      return {
        ...state,
        ...action.payload,
        filter: {
          ...state.filter,
          ...action.payload.filter,
        },
      };
    },
    resetProductFilter: () => initialState,
  },
});

export const { setProductFilter, resetProductFilter } =
  productFilterSlice.actions;
export default productFilterSlice.reducer;
